import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable()
export class LoginService {

  authenticated = false;

  token;

  constructor(private http: HttpClient, private router: Router) {
  }

  login(username: string, password: string) {

  		console.log(username, password);
        this.http.post('api/login', {username: username,password: password})
	    	.subscribe((resp: any) => {
	     
	      	this.router.navigate(['patients']);
	      	localStorage.setItem('auth_token', resp.token);
          this.token = resp.token;
	      
	      });
    }

  

    

}



// WEBPACK FOOTER //
// ./src/app/login.service.ts